import { lazy } from "react";
import AccountCircle from "@mui/icons-material/AccountCircle";

import { Navigate } from "react-router-dom";

const UserList = lazy(() => import("../components/userList"));
const UserCreate = lazy(() => import("../components/userCreate"));

const userRoute = {
  icon: AccountCircle,
  name: "User Management",
  link: "/user-management",
  path: "user-management",
  children: [
    {
      path: "users",
      element: <UserList />,
      permission: "User-Read",
      name: "Users",
      index: 10,
      link: "user-management/users",
      icon: AccountCircle,
    },
    {
      path: "users/create",
      element: <UserCreate />,
    },
    {
      path: "users/:id",
      element: <UserCreate />,
    },
    // {
    //   path: "transporter/view/:id",
    //   element: <TransporterView />,
    // },
    {
      path: "",
      element: <Navigate to="users" replace />,
    },
  ],
};
export default userRoute;
